import { Component, Input } from '@angular/core';

import { CompanyService } from '../companies/company.service';
import { SessionModel }  from '../sessions/models/session';
import { SessionService } from '../sessions/session.service';

@Component({
  selector   : 'wor-loan-car-activate',
  template: require('./loan-car-schedule.activate.component.html')
})
export class LoanCarActivateComponent {
  @Input() settings: any;

  session: SessionModel;

  constructor(
    public companyService: CompanyService,
    private sessionService: SessionService
  ) {}

  ngOnInit (): void {


    this.session = this.sessionService.base();


  }

  subscriptionUpgrade (): void {


    window.location.href = '#/subscription_type_upgrade';


    };


  }
